import {
  Autocomplete,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { FormTitle, Uploader } from 'components';
import axios from 'axios';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';

export const CreateBannerForm = ({ isEdit = false, currentData }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [type, setType] = useState('1');
  const [sliderType, setSliderType] = useState('slider_mini');
  const [link, setLink] = useState('');
  const [tags, setTags] = useState([]);
  const [title, setTitle] = useState('');
  const [image, setImage] = useState(null);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [categories, setCategories] = useState([]);
  const [imageMobile, setImageMobile] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState(null);
  const [selectedSubCategories, setSelectedSubCategories] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isPlaced, setPlaced] = useState(false);

  const placeData = useCallback(() => {
    setLink(currentData.link);
    setTitle(currentData.title);
    setImage(currentData?.image?.hash);
    setImageMobile(currentData?.imageMobile?.hash);
    if (currentData.tags.length > 0) {
      setSelectedTags(currentData.tags);
    }
    setSelectedCategories(currentData.categories[0] || null);
    setSelectedSubCategories(currentData.subCategories[0] || null);
    if (currentData.subCategories.length > 0) {
      setSubCategories(categories.filter((x) => x._id === currentData.categories[0]._id)[0].children);
    }
    setSliderType(currentData.type);
    if (currentData.product && currentData.product !== '' && products.length > 0) {
      setSelectedProduct(products.filter((x) => x._id === currentData.product)[0]);
    }
    setPlaced(true);
  }, [currentData, categories, products]);

  useEffect(() => {
    if (isEdit && tags.length > 0 && categories.length > 0 && !isPlaced) {
      placeData();
    }
  }, [isEdit, placeData, tags, categories, isPlaced]);

  useEffect(() => {
    if (
      ((type === '3' && link !== '') ||
        (type === '2' && selectedCategories !== null && selectedSubCategories !== null) ||
        (type === '1' && selectedCategories !== null)) &&
      title !== ''
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [image, imageMobile, link, selectedCategories, selectedSubCategories, selectedTags, title, type]);

  const onDeleteTag = (index) => {
    console.log(index, 'mamad');
  };

  const loadCategories = async () => {
    axios
      .get('/admin/category/list')
      .then(({ data }) => {
        setCategories(data.categories);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    loadCategories();
  }, []);

  const loadTags = () => {
    axios
      .get('/admin/content/tag/list?page=1&limit=50')
      .then(({ data }) => {
        const arr = [];
        data.data.map((x) => arr.push(x._id));
        setTags(arr);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    loadTags();
  }, []);

  const loadProducts = useCallback(() => {
    const address = 'admin/product/listByCategory';
    if (selectedCategories) {
      axios
        .get(`${address}?categoryID=${selectedCategories._id}`)
        .then(({ data }) => {
          setProducts(data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (selectedSubCategories) {
      axios
        .get(`${address}?subCategoryID=${selectedSubCategories._id}`)
        .then(({ data }) => {
          setProducts(data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [selectedCategories, selectedSubCategories]);

  useEffect(() => {
    loadProducts();
  }, [loadProducts]);

  const handleSubmit = () => {
    setLoading(true);
    setDisabled(true);
    try {
      const body = new FormData();
      body.append('type', sliderType);
      body.append('status', '1');
      if (image && typeof image !== 'string') {
        body.append('image', image);
      }
      if (imageMobile && typeof imageMobile !== 'string') {
        body.append('imageMobile', imageMobile);
      }
      if (isEdit) {
        body.append('_id', currentData._id);
      }
      let l = '';
      if (type === '1') {
        if (selectedProduct) {
          l = `/product/${selectedProduct._id}?title=${selectedProduct.name}`;
        } else if (selectedSubCategories) {
            l = `/search?category=${selectedCategories._id}&subCategory=${selectedSubCategories._id}&title=${selectedSubCategories.name}`;
          } else {
            l = `/search?category=${selectedCategories._id}&title=${selectedCategories.name}`;
          }
      } else if (type === '2') {
        if (selectedProduct) {
          l = `/product/${selectedProduct._id}&title=${selectedProduct.name}`;
        } else {
          l = `/search?category=${selectedCategories._id}&subCategory=${selectedSubCategories._id}&title=${selectedSubCategories.name}`;
        }
      } else {
        l = link;
      }
      console.log(l);
      body.append('link', l);
      body.append('title', title);
      body.append('tags', `${selectedTags.join(',')}`);
      if (selectedCategories !== null) {
        body.append('categories', selectedCategories._id);
      }
      if (selectedSubCategories !== null) {
        body.append('subCategories', selectedSubCategories._id);
      }
      if (selectedProduct !== null) {
        body.append('product', selectedProduct._id);
      }
      axios
        .post('/admin/content/upload', body, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          setLoading(false);
          setDisabled(true);
          setType('1');
          setSliderType('slider_mini');
          setLink('');
          setTitle('');
          setImage(null);
          setImageMobile(null);
          setSelectedTags([]);
          setSelectedCategories(null);
          setSelectedSubCategories(null);
          enqueueSnackbar('با موفقیت ثبت شد', { variant: 'success' });
          navigate(-1);
        })
        .catch((err) => {
          enqueueSnackbar('خطایی رخ داده است', { variant: 'error' });
          setLoading(false);
          setDisabled(true);
        });
    } catch (error) {
      console.log(error);
      enqueueSnackbar('خطایی رخ داده است', { variant: 'error' });
    }
  };

  const handleChange = (event) => {
    setSliderType(event.target.value);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <InputLabel>نوع بنر را برای کدام یک از دسته بندی های محصول می باشد</InputLabel>
          <Select value={sliderType} onChange={handleChange}>
            <MenuItem value={'slider_mini'}>Slider mini</MenuItem>
            <MenuItem value={'slider_square'}>Slider square</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {sliderType === 'slider_mini' ? (
        <Grid item xs={12}>
          <InputLabel>لطفا بنر متناسب با نسبت (1:2.25) بارگذاری نمایید</InputLabel>
          <Uploader setMedia={(e) => setImage(e)} media={image} width={337} />
        </Grid>
      ) : (
        <Grid item xs={12}>
          <InputLabel>لطفا بنر متناسب با نسبت (1:1) بارگذاری نمایید</InputLabel>
          <Uploader setMedia={(e) => setImageMobile(e)} media={imageMobile} width={225} />
        </Grid>
      )}
      <Grid item xs={12}>
        <InputLabel>اسلایدر مرتبط با کدام یک از موارد زیر است؟ </InputLabel>
        <FormControl>
          <RadioGroup
            value={type}
            onChange={(e) => setType(e.target.value)}
            sx={{ display: 'flex', flexDirection: 'row' }}
          >
            {TYPES.map((type, index) => (
              <FormControlLabel key={index} value={type.type} control={<Radio />} label={type.label} />
            ))}
          </RadioGroup>
        </FormControl>
      </Grid>
      {type === '2' || type === '1' ? (
        <Grid item xs={12}>
          <Autocomplete
            options={categories}
            getOptionLabel={(opt) => opt.name}
            value={selectedCategories}
            onChange={(e, newValue) => {
              setSubCategories(newValue.children);
              setSelectedCategories(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                label="اسلایدر برای کدام یک از دسته بندی های محصول می باشد"
                placeholder="انتخاب دسته بندی"
              />
            )}
          />
        </Grid>
      ) : null}
      {(type === '2' || type === '1') && (
        <Grid item xs={12}>
          <Autocomplete
            options={subCategories}
            getOptionLabel={(opt) => opt.name}
            value={selectedSubCategories}
            onChange={(e, newValue) => setSelectedSubCategories(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                label="زیر دسته بندی را انتخاب کنید"
                placeholder="جستجوی زیر دسته بندی"
              />
            )}
          />
        </Grid>
      )}
      {type === '2' && (
        <Grid item xs={12}>
          <Autocomplete
            options={products}
            getOptionLabel={(opt) => opt.name}
            value={selectedProduct}
            onChange={(e, newValue) => setSelectedProduct(newValue)}
            renderInput={(params) => (
              <TextField {...params} fullWidth label="عنوان محصول را انتخاب کنید" placeholder="جستجوی عنوان محصول" />
            )}
          />
        </Grid>
      )}
      {type === '3' && (
        <Grid item xs={12}>
          <TextField
            label="لینک مورد نظر را وارد کنید"
            placeholder="لینک"
            fullWidth
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <TextField
          label="عنوان اسلایدر را وارد کنید"
          placeholder="عنوان اسلایدر"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <FormTitle icon="tag_icon" label="برچسب ها" />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          options={tags}
          value={selectedTags}
          multiple
          onChange={(e, newValue) => setSelectedTags(newValue)}
          renderInput={(params) => <TextField {...params} placeholder="انتخاب برچسب" />}
        />
      </Grid>
      <Grid item xs={12}>
        <Stack flexDirection="row" alignItems="center" justifyContent="flex-start" flexWrap="wrap">
          {selectedTags.map((tag, index) => (
            <Chip key={index} label={tag} onDelete={() => onDeleteTag(index)} />
          ))}
        </Stack>
      </Grid>
      <Grid item xs={10} />
      <Grid item xs={2}>
        <Stack justifyContent="flex-end">
          <LoadingButton onClick={handleSubmit} disabled={disabled} loading={loading} variant="contained" size="large">
            ثبت بنر و فعالسازی
          </LoadingButton>
        </Stack>
      </Grid>
    </Grid>
  );
};

const InputLabel = ({ children }) => (
  <Typography fontSize={14} fontWeight={500} sx={{ color: '#475466', mb: '1rem' }}>
    {children}
  </Typography>
);

const TYPES = [
  { type: 1, label: 'دسته بندی محصولات بیز' },
  { type: 2, label: 'محصول بیز' },
  { type: 3, label: 'عمومی ( نیاز به لینک مشخص )' },
];
